export const tourSteps = [
  {
    selector: '.onboarding-header',
    position: 'right-center',
    title: 'Get started',
    content:
      "Track your journey here. Follow your onboarding progress, see what's next, and jump between sections anytime."
  },
  {
    selector: '.sidebar-messages',
    position: 'right-center',
    title: 'Smart suggestions',
    content:
      'This card shows helpful alerts, messages, and tips that update automatically as you move through onboarding.'
  },
  {
    selector: '.assistance-card',
    position: 'right-bottom',
    title: 'Help center',
    content:
      'Need help along the way? This card shares real-time tips, quick links, and live chat support based on where you are in the process.'
  },
  {
    selector: '.stepper-content',
    position: 'left-center',
    title: 'Myriad Motion',
    content:
      "On your main interactive screen, you'll find smart tools, configurations, and real-time details that help move you through onboarding."
  },
  {
    selector: '.onboarding-footer',
    position: 'top-center',
    title: 'Footer actions',
    content:
      "Your journey, your pace. Move forward, revisit, or even skip a step if needed - though we recommend completing each one in order. If you skip a step, you'll get friendly reminders to finish it later."
  }
];
